<template>
  <v-content class="exportaciones-page">
    <v-container
      fluid
      class="exportaciones-container"
    >
      <v-card
        class="
          exportaciones-panel
          elevation-5
        "
      >
        <v-toolbar
          dense
          dark
          color="deep-orange"
          elevation="2"
        >
          <v-toolbar-title>
            Exportaciones programadas
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn
            text
            small
            :loading="loading"
            @click="consultar"
          >
            Actualizar
            <v-icon right>
              mdi-refresh
            </v-icon>
          </v-btn>
        </v-toolbar>

        <v-row
          class="
            resumen-exportaciones
            ma-0
            pa-4
          "
        >
          <v-col
            v-for="tarjeta in tarjetasResumen"
            :key="tarjeta.clave"
            cols="12"
            sm="6"
            md="4"
            class="
              resumen-exportaciones__item
              pa-2
            "
          >
          <v-card
            outlined
            ripple
            role="button"
            tabindex="0"
            class="
              resumen-card
              fill-height
            "
            :class="{
              'resumen-card--activo':
                filtroRapido ===
                tarjeta.clave,
            }"
            @click="
              seleccionarFiltro(
                tarjeta.clave
              )
            "
            @keyup.enter="
              seleccionarFiltro(
                tarjeta.clave
              )
            "
          >
            <v-card-text>
              <div
                class="
                  d-flex
                  align-center
                  justify-space-between
                "
              >
                <div>
                  <div
                    class="
                      caption
                      text-uppercase
                      grey--text
                      text--darken-1
                    "
                  >
                    {{ tarjeta.etiqueta }}

                    <v-icon
                      v-if="
                        filtroRapido ===
                        tarjeta.clave
                      "
                      x-small
                      color="deep-orange"
                      class="ml-1"
                    >
                      mdi-check-circle
                    </v-icon>
                  </div>

                  <div
                    class="
                      display-1
                      font-weight-medium
                      mt-1
                    "
                  >
                    {{ tarjeta.valor }}
                  </div>
                </div>

                <v-avatar
                  :color="tarjeta.color"
                  size="42"
                  dark
                >
                  <v-icon dark>
                    {{ tarjeta.icono }}
                  </v-icon>
                </v-avatar>
              </div>
            </v-card-text>
          </v-card>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-card-title
          class="programaciones-toolbar"
        >
          <v-btn
            small
            elevation="2"
            color="blue-grey darken-2"
            dark
            class="mx-2"
            :disabled="loading"
            @click="nuevaProgramacion"
          >
            Nueva programación
            <v-icon right>
              mdi-plus
            </v-icon>
          </v-btn>

          <v-chip
            small
            outlined
            color="primary"
            class="mx-2"
          >
            {{ resumenProgramaciones }}
          </v-chip>

          <v-chip
            v-if="
              filtroRapido !== 'total'
            "
            small
            close
            color="deep-orange"
            text-color="white"
            class="mx-2"
            @click:close="
              seleccionarFiltro(
                'total'
              )
            "
          >
            Filtrando:
            {{ nombreFiltroActivo }}
          </v-chip>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="mx-2"
            single-line
            hide-details
            maxlength="150"
          ></v-text-field>
        </v-card-title>

        <exportaciones-programadas-table
          :items="configuracionesFiltradas"
          :loading="loading"
          :search="search"
          :codigo-procesando="
            codigoProcesando
          "
          @abrir-archivo="abrirArchivo"
          @editar="editarProgramacion"
          @duplicar="duplicarProgramacion"
          @cambiar-estado="
            solicitarCambioEstado
          "
          @eliminar="
            solicitarEliminar
          "
          @historial="
            abrirHistorial
          "
          @vista-previa="
            abrirVistaPrevia
          "
          @ejecutar="
            abrirDialogEjecutar
          "
        />
      </v-card>

      <exportacion-programada-dialog
        v-model="dialogNueva"
        :configuracion="configuracionEditar"
        :modo="modoDialogo"
        @guardada="programacionGuardada"
      />

      <historial-exportacion-dialog
        v-model="dialogHistorial"
        :configuracion="
          configuracionHistorial
        "
      />

      <vista-previa-exportacion-dialog
        v-model="dialogVistaPrevia"
        :configuracion="
          configuracionVistaPrevia
        "
      />

      <ejecutar-exportacion-dialog
        v-model="dialogEjecutar"
        :configuracion="
          configuracionEjecutar
        "
        @inicio="inicioEjecucion"
        @fin="finEjecucion"
        @ejecutada="ejecucionTerminada"
      />

      <v-dialog
        v-model="dialogEstado"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-card-title>
            {{
              configuracionAccion &&
              esActiva(
                configuracionAccion
              )
                ? "Desactivar programación"
                : "Activar programación"
            }}
          </v-card-title>

          <v-card-text>
            {{
              configuracionAccion &&
              esActiva(
                configuracionAccion
              )
                ? "La programación dejará de ejecutarse hasta que sea activada nuevamente."
                : "La programación volverá a ejecutarse según su horario configurado."
            }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text
              :disabled="procesandoAccion"
              @click="cerrarDialogEstado"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="deep-orange"
              dark
              :loading="procesandoAccion"
              @click="confirmarCambioEstado"
            >
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogEliminar"
        max-width="500px"
        persistent
      >
        <v-card>
          <v-card-title>
            Eliminar programación
          </v-card-title>

          <v-card-text>
            <p>
              ¿Deseas eliminar
              <strong>
                {{
                  configuracionAccion
                    ? configuracionAccion.nombre
                    : ""
                }}
              </strong>?
            </p>

            <v-alert
              dense
              outlined
              type="warning"
            >
              La programación dejará de
              ejecutarse. El historial de
              ejecuciones se conservará.
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              text
              :disabled="procesandoAccion"
              @click="cerrarDialogEliminar"
            >
              Cancelar
            </v-btn>

            <v-btn
              color="error"
              dark
              :loading="procesandoAccion"
              @click="confirmarEliminar"
            >
              Eliminar
              <v-icon right>
                mdi-delete
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="error"
        color="error"
        :timeout="5000"
        bottom
        right
      >
        {{ msgError }}
      </v-snackbar>

      <v-snackbar
        v-model="info"
        color="info"
        :timeout="5000"
        bottom
        right
      >
        {{ msgInfo }}
      </v-snackbar>

      <v-snackbar
        v-model="success"
        color="success"
        :timeout="3000"
        bottom
        right
      >
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import ExportacionesProgramadasTable from
  "@/components/reportes/ExportacionesProgramadasTable.vue";
import ExportacionProgramadaDialog from
  "@/components/reportes/ExportacionProgramadaDialog.vue";
import HistorialExportacionDialog from
  "@/components/reportes/HistorialExportacionDialog.vue";
import VistaPreviaExportacionDialog from
  "@/components/reportes/VistaPreviaExportacionDialog.vue";
import EjecutarExportacionDialog from
  "@/components/reportes/EjecutarExportacionDialog.vue";
import {
  cambiarEstadoExportacionProgramada,
  eliminarExportacionProgramada,
  listarExportacionesProgramadas,
} from "@/utils/exportacionesProgramadasApi";

export default {
  name: "ExportacionesProgramadas",

  components: {
    ExportacionesProgramadasTable,
    ExportacionProgramadaDialog,
    HistorialExportacionDialog,
    VistaPreviaExportacionDialog,
    EjecutarExportacionDialog,
  },

  data: () => ({
    loading: false,
    error: false,
    msgError: "",
    search: "",
    filtroRapido: "total",
    configuraciones: [],
    dialogNueva: false,
    configuracionEditar: null,
    modoDialogo: "crear",
    configuracionAccion: null,
    configuracionHistorial: null,
    dialogHistorial: false,
    configuracionVistaPrevia: null,
    dialogVistaPrevia: false,
    configuracionEjecutar: null,
    dialogEjecutar: false,
    dialogEstado: false,
    dialogEliminar: false,
    procesandoAccion: false,
    codigoProcesando: "",
    success: false,
    msgSuccess: "",
    info: false,
    msgInfo: "",
  }),

  computed: {
    configuracionesFiltradas() {
      if (
        this.filtroRapido === "total"
      ) {
        return this.configuraciones;
      }

      return this.configuraciones.filter(
        configuracion => {
          const estado =
            configuracion.estado || {};

          const ultima =
            configuracion
              .ultima_ejecucion || null;

          if (
            this.filtroRapido ===
            "activas"
          ) {
            return (
              estado.id === 1 ||
              estado.nombre === "activo"
            );
          }

          if (
            this.filtroRapido ===
            "inactivas"
          ) {
            return !(
              estado.id === 1 ||
              estado.nombre === "activo"
            );
          }

          if (
            this.filtroRapido ===
            "error"
          ) {
            return Boolean(
              ultima &&
              [
                "error",
                "fallida",
                "parcial",
              ].includes(
                ultima.estatus
              )
            );
          }

          if (
            this.filtroRapido ===
            "sin-datos"
          ) {
            return Boolean(
              ultima &&
              ultima.estatus ===
                "sin_datos"
            );
          }

          return true;
        }
      );
    },

    nombreFiltroActivo() {
      const nombres = {
        total: "Todas",
        activas: "Activas",
        inactivas: "Inactivas",
        error: "Con error",
        "sin-datos": "Sin datos",
      };

      return (
        nombres[this.filtroRapido] ||
        "Todas"
      );
    },

    totalProgramaciones() {
      return this.configuraciones.length;
    },

    totalActivas() {
      return this.configuraciones.filter(
        configuracion =>
          configuracion.estado &&
          (
            configuracion.estado.id === 1 ||
            configuracion.estado.nombre ===
              "activo"
          )
      ).length;
    },

    totalInactivas() {
      return this.configuraciones.filter(
        configuracion =>
          configuracion.estado &&
          (
            configuracion.estado.id !== 1 &&
            configuracion.estado.nombre !==
              "activo"
          )
      ).length;
    },

    totalConError() {
      return this.configuraciones.filter(
        configuracion => {
          const ultima =
            configuracion.ultima_ejecucion;

          return Boolean(
            ultima &&
            (
              ultima.estatus === "error" ||
              ultima.estatus === "fallida" ||
              ultima.estatus === "parcial"
            )
          );
        }
      ).length;
    },

    totalSinDatos() {
      return this.configuraciones.filter(
        configuracion =>
          configuracion.ultima_ejecucion &&
          configuracion
            .ultima_ejecucion
            .estatus === "sin_datos"
      ).length;
    },

    tarjetasResumen() {
      return [
        {
          clave: "total",
          etiqueta: "Total",
          valor: this.totalProgramaciones,
          color: "primary",
          icono: "mdi-format-list-bulleted",
        },
        {
          clave: "activas",
          etiqueta: "Activas",
          valor: this.totalActivas,
          color: "success",
          icono: "mdi-play-circle",
        },
        {
          clave: "inactivas",
          etiqueta: "Inactivas",
          valor: this.totalInactivas,
          color: "grey",
          icono: "mdi-pause-circle",
        },
        {
          clave: "error",
          etiqueta: "Con error",
          valor: this.totalConError,
          color: "error",
          icono: "mdi-alert-circle",
        },
        {
          clave: "sin-datos",
          etiqueta: "Sin datos",
          valor: this.totalSinDatos,
          color: "info",
          icono: "mdi-information",
        },
      ];
    },

    resumenProgramaciones() {
      const visibles =
        this.configuracionesFiltradas
          .length;

      const total =
        this.configuraciones.length;

      if (
        this.filtroRapido !== "total"
      ) {
        return (
          `${visibles} de ${total} ` +
          `${
            total === 1
              ? "programación"
              : "programaciones"
          }`
        );
      }

      return `${total} ${
        total === 1
          ? "programación"
          : "programaciones"
      }`;
    },
  },

  watch: {
    dialogNueva(valor) {
      if (!valor) {
        this.configuracionEditar =
          null;

        this.modoDialogo =
          "crear";
      }
    },

    dialogVistaPrevia(valor) {
      if (!valor) {
        this.configuracionVistaPrevia =
          null;
      }
    },

    dialogEjecutar(valor) {
      if (!valor) {
        this.configuracionEjecutar =
          null;
      }
    },
  },

  mounted() {
    this.consultar();
  },

  methods: {
    seleccionarFiltro(clave) {
      const nuevaClave =
        clave || "total";

      if (
        nuevaClave !== "total" &&
        this.filtroRapido ===
          nuevaClave
      ) {
        this.filtroRapido =
          "total";
        return;
      }

      this.filtroRapido =
        nuevaClave;
    },

    nuevaProgramacion() {
      this.configuracionEditar = null;
      this.modoDialogo = "crear";
      this.dialogNueva = true;
    },

    async editarProgramacion(
      configuracion
    ) {
      this.modoDialogo = "editar";
      this.configuracionEditar =
        configuracion;

      await this.$nextTick();

      this.dialogNueva = true;
    },

    async duplicarProgramacion(
      configuracion
    ) {
      this.modoDialogo = "duplicar";
      this.configuracionEditar =
        configuracion;

      await this.$nextTick();

      this.dialogNueva = true;
    },

    async abrirDialogEjecutar(
      configuracion
    ) {
      this.configuracionEjecutar =
        configuracion;

      await this.$nextTick();

      this.dialogEjecutar = true;
    },

    inicioEjecucion(configuracion) {
      this.codigoProcesando =
        configuracion
          ? configuracion.codigo
          : "";
    },

    finEjecucion() {
      this.codigoProcesando = "";
    },

    async ejecucionTerminada(resultado) {
      await this.consultar();

      /*
       * El resultado completo se presenta dentro
       * del diálogo. La página solo actualiza los
       * contadores y la última ejecución.
       */
      if (
        resultado &&
        resultado.estatus ===
          "sin_datos"
      ) {
        this.info = true;
        this.msgInfo =
          resultado.mensaje ||
          "No se encontraron registros para el periodo solicitado";
      }
    },

    abrirHistorial(configuracion) {
      this.configuracionHistorial =
        configuracion;

      this.dialogHistorial = true;
    },

    async abrirVistaPrevia(
      configuracion
    ) {
      this.configuracionVistaPrevia =
        configuracion;

      await this.$nextTick();

      this.dialogVistaPrevia = true;
    },

    esActiva(configuracion) {
      return Boolean(
        configuracion &&
        configuracion.estado &&
        (
          configuracion.estado.id === 1 ||
          configuracion.estado.nombre ===
            "activo"
        )
      );
    },

    solicitarCambioEstado(
      configuracion
    ) {
      this.configuracionAccion =
        configuracion;

      this.dialogEstado = true;
    },

    cerrarDialogEstado() {
      if (this.procesandoAccion) {
        return;
      }

      this.dialogEstado = false;
      this.configuracionAccion = null;
    },

    async confirmarCambioEstado() {
      if (!this.configuracionAccion) {
        return;
      }

      const configuracion =
        this.configuracionAccion;

      const nuevoEstado =
        !this.esActiva(configuracion);

      this.procesandoAccion = true;
      this.codigoProcesando =
        configuracion.codigo;

      try {
        const resultado =
          await cambiarEstadoExportacionProgramada(
            this.$session,
            configuracion.codigo,
            nuevoEstado
          );

        if (!resultado.correcto) {
          this.mostrarError(
            resultado.mensaje ||
              "No fue posible cambiar el estado"
          );
          return;
        }

        this.dialogEstado = false;
        this.configuracionAccion = null;

        this.success = true;
        this.msgSuccess =
          nuevoEstado
            ? "Programación activada correctamente"
            : "Programación desactivada correctamente";

        await this.consultar();
      } catch (error) {
        console.error(error);

        this.mostrarError(
          error.response &&
          error.response.data &&
          error.response.data.mensaje
            ? error.response.data.mensaje
            : "No fue posible cambiar el estado"
        );
      } finally {
        this.procesandoAccion = false;
        this.codigoProcesando = "";
      }
    },

    solicitarEliminar(configuracion) {
      this.configuracionAccion =
        configuracion;

      this.dialogEliminar = true;
    },

    cerrarDialogEliminar() {
      if (this.procesandoAccion) {
        return;
      }

      this.dialogEliminar = false;
      this.configuracionAccion = null;
    },

    async confirmarEliminar() {
      if (!this.configuracionAccion) {
        return;
      }

      const configuracion =
        this.configuracionAccion;

      this.procesandoAccion = true;
      this.codigoProcesando =
        configuracion.codigo;

      try {
        const resultado =
          await eliminarExportacionProgramada(
            this.$session,
            configuracion.codigo
          );

        if (!resultado.correcto) {
          this.mostrarError(
            resultado.mensaje ||
              "No fue posible eliminar la programación"
          );
          return;
        }

        this.dialogEliminar = false;
        this.configuracionAccion = null;

        this.success = true;
        this.msgSuccess =
          "Programación eliminada correctamente";

        await this.consultar();
      } catch (error) {
        console.error(error);

        this.mostrarError(
          error.response &&
          error.response.data &&
          error.response.data.mensaje
            ? error.response.data.mensaje
            : "No fue posible eliminar la programación"
        );
      } finally {
        this.procesandoAccion = false;
        this.codigoProcesando = "";
      }
    },

    async consultar() {
      this.loading = true;
      this.error = false;

      try {
        const resultado =
          await listarExportacionesProgramadas(
            this.$session,
            {
              incluirInactivas: true,
            }
          );

        if (!resultado.correcto) {
          this.mostrarError(
            resultado.mensaje ||
              "No fue posible consultar las exportaciones"
          );
          return;
        }

        this.configuraciones =
          Array.isArray(
            resultado.configuraciones
          )
            ? resultado.configuraciones
            : [];
      } catch (error) {
        console.error(error);

        if (
          error.response &&
          error.response.status === 403
        ) {
          this.$router.push("/403");
          return;
        }

        if (
          error.message ===
            "La sesión no está disponible" ||
          error.message ===
            "El token de sesión no está disponible"
        ) {
          this.$router.push("/login");
          return;
        }

        this.mostrarError(
          "El servicio no se encuentra disponible en estos momentos"
        );
      } finally {
        this.loading = false;
      }
    },

    mostrarError(mensaje) {
      this.error = true;
      this.msgError = mensaje;
    },

    async programacionGuardada() {
      this.success = true;
      if (
        this.modoDialogo === "editar"
      ) {
        this.msgSuccess =
          "Programación actualizada correctamente";
      } else if (
        this.modoDialogo === "duplicar"
      ) {
        this.msgSuccess =
          "Copia creada correctamente";
      } else {
        this.msgSuccess =
          "Programación creada correctamente";
      }

      await this.consultar();
    },

    abrirArchivo(url) {
      if (!url) {
        return;
      }

      window.open(
        url,
        "_blank",
        "noopener,noreferrer"
      );
    },
  },
};
</script>

<style scoped>
.exportaciones-page {
  background:
    linear-gradient(
      180deg,
      #f4f5f7 0%,
      #fafafa 100%
    );
  min-height: 100vh;
}

.exportaciones-container {
  padding: 28px;
}

.exportaciones-panel {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 6px;
}

.resumen-exportaciones {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  gap: 8px;
}

.resumen-exportaciones__item {
  flex: 1 1 220px;
  max-width: 270px;
}

.resumen-card {
  min-height: 126px;
  cursor: pointer;
  user-select: none;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease;
}

.resumen-card:focus {
  outline:
    2px solid
    rgba(255, 87, 34, 0.45);
  outline-offset: 2px;
}

.resumen-card--activo {
  border-color:
    #ff5722 !important;
  background:
    rgba(
      255,
      87,
      34,
      0.055
    );
  box-shadow:
    0 5px 15px
    rgba(255, 87, 34, 0.16);
}

.resumen-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 5px 14px
    rgba(0, 0, 0, 0.1);
}

.programaciones-toolbar {
  padding-top: 20px;
  padding-bottom: 20px;
}

@media (max-width: 1264px) {
  .resumen-exportaciones__item {
    max-width: none;
  }
}

@media (max-width: 600px) {
  .exportaciones-container {
    padding: 8px;
  }

  .resumen-exportaciones {
    padding: 8px !important;
  }

  .resumen-exportaciones__item {
    flex-basis: 100%;
  }

  .programaciones-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .programaciones-toolbar .v-input {
    width: 100%;
  }
}
</style>
